import axios from "axios";
import { useMutation } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useCreateBulkOrder(options = {}) {
  const { accessToken } = useSession();

  const action = async (data) => {
    const formData = new FormData();
    formData.append("file", data.file);

    return axios.post(`${config.orderApiUrl}/v1/orders/uploads`, formData, {
      headers: {
        ...requestHeaders(accessToken),
        "Content-Type": "multipart/form-data",
      },
      params: {
        ...(data.validations ? {} : { validations: false }),
      },
      timeout: 60000,
    });
  };

  const mutation = useMutation((data) => action(data), {
    onError: (error, variables, context) => {
      error.readableError = error.response?.data?.message;
      error.isTimeout =
        error?.code === "ECONNABORTED" || error.response?.status === 504;
    },
  });

  const isTimeout =
    mutation.isError &&
    (mutation.error?.code === "ECONNABORTED" ||
      mutation.error?.response?.status === 504);

  const timeoutType = isTimeout
    ? mutation.error?.code === "ECONNABORTED"
      ? "client"
      : mutation.error?.response?.status === 504
        ? "server"
        : null
    : null;

  return {
    createBulkOrder: mutation.mutateAsync,
    createBulkOrderStatus: {
      ...mutation,
      isTimeout,
      timeoutType,
    },
  };
}
